(function () {
    'use strict';

    angular
        .module('franchiser.components')
        .controller('CompanyAssociationHistoryController', CompanyAssociationHistoryController)

    /** @ngInject */
    function CompanyAssociationHistoryController($httpParamSerializer, $q, CompanyService, PersonService, UtilHelper,
        LoadingHelper, ROUTES, MeService) {
        const vm = this;

        let isTableSearch = false;
        let forcePaginationReset = false;
        let allCompanies = [];

        vm.isSearchDisabled = () => {
            if (vm.selectedCompany || (vm.selectedSearchField && vm.searchText))
                return false;

            return true;
        }

        vm.isClearDisabled = () => {
            if (isTableSearch)
                return false;

            if (vm.selectedCompany || vm.selectedSearchField || vm.searchText)
                return false;

            return true;
        }

        vm.doSearch = (event, isFromButton) => {
            if (!vm.isSearchDisabled() && (event && event.keyCode == 13) || isFromButton) {
                forcePaginationReset = true;
                vm.isFirstCall = false;
                vm.isLoading = true;

                vm.tableCallServer();
            }
        }

        vm.clearSearch = () => {
            vm.selectedCompany = null;
            vm.selectedSearchField = null;
            vm.searchText = null;
            vm.personAssociationHistory = [];
            vm.isFirstCall = true;

            isTableSearch = false;
        }

        vm.tableCallServer = (tableState, stCtrl) => {
            if (!vm.stCtrl && stCtrl)
                vm.stCtrl = stCtrl;

            if (!tableState && vm.stCtrl) {
                vm.stCtrl.pipe();
                return;
            }

            if (vm.isFirstCall) {
                vm.isLoading = false;
                return;
            }

            vm.isLoading = true;

            if (forcePaginationReset) {
                tableState.pagination.start = 0;
                forcePaginationReset = false;
            }

            const pagination = tableState.pagination;
            const start = pagination.start || 0;
            const number = pagination.number || 10;

            getAssociationHistory(start, number, tableState);
        }

        vm.getCompanies = search => {
            if (!search) {
                vm.companies = [];
                return;
            }

            vm.companies = allCompanies.filter(company => filterCompany(company, search))
        }

        vm.configureReportDownload = () => {
            LoadingHelper.startLoading('.btn-download', true);
            vm.isLoadingDownloadData = true;

            const parameters = prepareParameters(0, 0, null);

            MeService
                .getDownloadToken()
                .then(success => {
                    vm.isLoadingDownloadData = false;
                    LoadingHelper.stopLoading('.btn-download', true);

                    window.open(`${ROUTES.API}/association-history-report?Token=${success}&${$httpParamSerializer(parameters)}`, '_blank');
                }, error => {
                    vm.isLoadingDownloadData = false;
                    LoadingHelper.stopLoading('.btn-download', true);
                    UtilHelper.errorCallback(error);
                })
        }

        init();

        function getAssociationHistory(skip, perPage, tableState) {
            let parameters = prepareParameters(skip, perPage, tableState);

            PersonService
                .getAssociationHistory(parameters)
                .then(success => {
                    vm.personAssociationHistory = success.Registers;
                    tableState.pagination.numberOfPages = success.NumberOfPages;

                    vm.isLoading = false;
                }, error => {
                    vm.personAssociationHistory = [];
                    vm.isLoading = false;
                    UtilHelper.errorCallback(error);
                });
        }

        function getAllCompaniesResumed() {
            return CompanyService
                .getAllResumed()
                .then(success => {
                    allCompanies = success;
                }, error => {
                    UtilHelper.errorCallback(error);
                    LoadingHelper.stopLoading('.custom-filters');
                })
        }

        function filterCompany(company, search) {
            if (company.FantasyName == null)
                company.FantasyName = '';

            if (company.CorporateName == null)
                company.CorporateName = '';

            if (company.UniqueCode == null)
                company.UniqueCode = '';

            if (company.ExternalCode == null)
                company.ExternalCode = '';

            if (company.FantasyName.toLowerCase().includes(search.toLowerCase()) || company.CorporateName.toLowerCase().includes(search.toLowerCase()) || company.UniqueCode.toString().includes(search) || company.ExternalCode.toString().includes(search))
                return company;
        }

        function prepareParameters(skip, perPage, tableState) {
            let params = {
                Skip: skip,
                PerPage: perPage,
                OrderBy: 'Person.Name',
                OrderDescending: false
            }

            if (vm.selectedCompany || (vm.selectedSearchField && vm.searchText))
                isTableSearch = true;

            if (vm.selectedCompany)
                params.CompanyId = vm.selectedCompany.Id;

            if (tableState && tableState.sort.predicate) {
                params.OrderBy = tableState.sort.predicate;
                params.OrderDescending = tableState.sort.reverse;
            }

            if (vm.selectedSearchField && vm.searchText)
                params[vm.selectedSearchField.Value] = vm.searchText;

            return params;
        }

        function init() {
            vm.selectedCompany;
            vm.selectedSearchField;
            vm.searchText;
            vm.isLoading = false;
            vm.isFirstCall = true;

            vm.searchFields = [{
                Value: 'Document',
                Description: 'Documento'
            }, {
                Value: 'Name',
                Description: 'Nome'
            }, {
                Value: 'Email',
                Description: 'E-mail'
            }];

            LoadingHelper.startLoading('.custom-filters');

            $q.all([getAllCompaniesResumed()])
                .then(() => {
                    LoadingHelper.stopLoading('.custom-filters');
                })
        }
    }
}());